<template>
  <v-tabs
    background-color="primary"
    color="white"
  >
    <v-tab
      v-for="item in menuItems"
      :key="item.name"
      :to="item.link"
      exact
    >
      {{ item.name }}
    </v-tab>
  </v-tabs>
</template>

<script>
import { mapState } from 'vuex'
import { hasRoutePermission } from '@/router'

export default {
  computed: {
    ...mapState('navigation', [ 'secondaryNav' ]),
    menuItems () {
      return this.secondaryNav.filter(item => hasRoutePermission(item.link))
    }
  }
}
</script>

<style lang="scss">

</style>
